<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>위생 교육</p></li>
            <li><p>식품 위생 교육 안내</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>식품 위생 교육 안내</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="rule_list">
            <ul class="rule_list_ul">
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">온라인 식품위생교육 안내</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="col fix180">
                        <div class="cell"></div>
                      </div>
                      <!--
                      <div class="col">
                        <div class="row">
                          <div class="cell"><p>신규 영업자</p></div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>일반음식점</p></div>
                          <div class="cell"><p>위탁급식업</p></div>
                          <div class="cell"><p>집단급식소</p></div>
                        </div>
                      </div>
                      -->
                      <div class="col">
                        <div class="row">
                          <div class="cell"><p>기존 영업자</p></div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>일반음식점</p></div>
                          <div class="cell"><p>위탁급식업</p></div>
                          <div class="cell"><p>집단급식소</p></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>근거법령</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p>
                            「식품위생법」 제41조, 동법 시행령 제27조 및
                            시행규칙 제51조 내지 제52조
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육 대상</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <!--
                          <div class="cell">
                            <p>
                              일반음식점<br />신규영업자<br />[신규창업]<br /><br />
                              일반음식점<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              위탁급식<br />신규영업자<br />[신규창업]<br /><br />
                              위탁급식<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              집단 급식소<br />신규영업자<br />[신규창업]<br /><br />
                              집단 급식소<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          -->
                          <div class="cell">
                            <p>일반음식점<br />영업자<br />[보수교육]</p>
                          </div>
                          <div class="cell">
                            <p>위탁급식<br />영업자<br />[보수교육]</p>
                          </div>
                          <div class="cell">
                            <p>집단급식소<br />영업자<br />[보수교육]</p>
                          </div>
                        </div>
                        <div class="row">
                          <!--
                          <div class="cell"><p>-</p></div>
                          <div class="cell" style="flex: 2;">
                            <p>
                              <span class="red">
                                ※ 조리사 면허, 영양사 면허,<br />
                                위생사 면허를 받은 자는 면제<br />
                                ※ 종사하는 조리사 및 영양사가<br />
                                식품위생관리 책임자로 지정되어<br />
                                해당 연도의 조리사 및 영양사<br />
                                교육을 받은 경우 면제
                              </span>
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              <span class="blue">
                                ※ 영업신고 후<br />
                                그다음 해부터<br />
                                매년 받는<br />
                                보수교육입니다.
                              </span>
                            </p>
                          </div>
                          -->
                          <div class="cell">
                            <p>
                                                        <span class="blue">
                                                            ※ 영업신고 후<br>
                                                            그다음 해부터<br>
                                                            매년 받는<br>
                                                            보수교육입니다.
                                                        </span>
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              <span class="blue">
                                ※ 영업신고 후 그다음 해부터<br />
                                매년 받는 보수교육입니다.<br />
                              </span>
                              <span class="red">
                                ※ 종사하는 조리사 및 영양사가<br />
                                식품위생관리 책임자로 지정되어<br />
                                해당 연도의 조리사 및 영양사<br />
                                교육을 받은 경우 면제
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육 시간</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <!--
                          <div class="cell">
                            <p>6시간(결제일 기준 1개월 이내 수강 가능)</p>
                          </div>
                          -->
                          <div class="cell">
                            <p>3시간(결제일 기준 1개월 이내 수강 가능)</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>수강료</p></div>
                      </div>
                      <div class="col">
                        <div class="row row_bg">
<!--                          <div class="cell" style="flex: 3;">-->
<!--                            <p>{{ `${$Util.formatNumber(codeList[0].price)}원` }}</p>-->
<!--                          </div>-->
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[3].price)}원` }}</p></div>
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[4].price)}원` }}</p></div>
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[5].price)}원` }}</p></div>
                        </div>
                        <div class="row">
                          <div class="cell">
                            <p>
                              ※ <span class="red">결제 완료 해당연도에 수강 완료</span>해야 하며,<br>
                              수강취소/환불신청 시 환불금액은 적용기준에  따라 달라집니다.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>결제방법</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>신용카드 결제, 휴대폰 결제, 가상계좌 입금</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육신청 절차</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>
                              회원가입 → 로그인 → 교육신청 → 결제<br />
                              <span class="blue"
                                >※ 교육신청 시 대표자 또는
                                식품위생관리책임자</span
                              >
                              <span class="red">선택</span><br />
                              <span class="blue"
                                >식품위생관리책임자는 식품위생관리책임자 지정
                                신청서 작성 후</span
                              >
                              <span class="red">업로드(자료실다운로드)</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>수강 절차</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>
                              “나의 학습방” 입장 → 강의실 입장 → 수강 → 시험평가
                              → 설문지 작성 → 수료증 출력<br />
                              <span class="blue"
                                >※ 시험평가(60점 이상), 설문지 작성 완료
                                후</span
                              >
                              <span class="red">수료 완료</span><br />
                              <span class="blue"
                                >설문지 작성 후 상호, 사업장 주소</span
                              >
                              <span class="red">변경 가능</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">집합 식품위생교육 안내</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="col fix180">
                        <div class="cell"></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell"><p>신규 영업자</p></div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>일반음식점</p></div>
                          <div class="cell"><p>위탁급식업</p></div>
                          <div class="cell"><p>집단급식소</p></div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell"><p>기존 영업자</p></div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>일반음식점</p></div>
                          <div class="cell"><p>위탁급식업</p></div>
                          <div class="cell"><p>집단급식소</p></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>근거법령</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p>
                            「식품위생법」 제41조, 동법 시행령 제27조 및
                            시행규칙 제51조 내지 제52조
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육 대상</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>
                              일반음식점<br />신규영업자<br />[신규창업]<br /><br />
                              일반음식점<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              위탁급식<br />신규영업자<br />[신규창업]<br /><br />
                              위탁급식<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          <div class="cell">
                            <p>
                              집단 급식소<br />신규영업자<br />[신규창업]<br /><br />
                              집단 급식소<br />영업자의<br />지위승계자<br />[명의변경]
                            </p>
                          </div>
                          <div class="cell">
                            <p>일반음식점<br />영업자<br />[보수교육]</p>
                          </div>
                          <div class="cell">
                            <p>위탁급식<br />영업자<br />[보수교육]</p>
                          </div>
                          <div class="cell">
                            <p>집단급식소<br />영업자<br />[보수교육]</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>-</p></div>
                          <div class="cell" style="flex: 2;">
                            <p>-</p>
                          </div>
                          <div class="cell" style="flex: 3">
                            <p>
                              <span class="blue">
                                ※ 영업신고 후 그다음 해부터 매년 받는<br />
                                보수교육입니다.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육 시간</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell"><p>6시간</p></div>
                          <div class="cell"><p>3시간</p></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>수강료</p></div>
                      </div>
                      <div class="col">
                        <div class="row row_bg">
                          <div class="cell" style="flex: 3;">
                            <p>{{ `${$Util.formatNumber(codeList[6].price)}원` }}</p>
                          </div>
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[9].price)}원` }}</p></div>
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[10].price)}원` }}</p></div>
                          <div class="cell"><p>{{ `${$Util.formatNumber(codeList[11].price)}원` }}</p></div>
                        </div>
                        <div class="row">
                          <div class="cell">
                            <p>
                              <span class="blue">
                                ※ 취소 의사를 밝히지 않고
                                <span class="red"
                                  >교육 불참 시 교육비는 반환하지 않습니다.</span
                                ><br />
                                수강취소/환불신청 시 환불금액은 적용기준에 따라
                                달라집니다.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>결제방법</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>신용카드 결제, 휴대폰 결제, 가상계좌 입금</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>교육신청 절차</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>
                              회원가입 → 로그인 → 교육신청(교육장소 선택) → 결제
                              → 교육접수증 출력<br />
                              <span class="blue"
                                >※ 교육신청 시 대표자 또는
                                식품위생관리책임자</span
                              >
                              <span class="red">선택</span><br />
                              <span class="blue"
                                >식품위생관리책임자는 식품위생관리책임자 지정
                                신청서 작성 후</span
                              >
                              <span class="red">업로드(자료실다운로드)</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix180">
                        <div class="cell"><p>수강 절차</p></div>
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="cell">
                            <p>
                              집합 식품위생교육 참석 → 수강 → 설문지 작성 → 수료
                              완료<br />
                              <span class="blue"
                                >※ 수료증 출력 전 상호, 사업장 주소</span
                              >
                              <span class="red">변경 가능</span><br />
                              <span class="blue"
                                >수료증은 교육 종료 후 직접 출력이 가능하며,
                                팩스로도 수령 가능합니다.</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'hygn-notice-index',
  description: '식품위생교육안내',
  data() {
    return {
      codeList: {}
    }
  },
  async created() {
    await this.fetchCode()
  },
  methods: {
    fetchCode: async function() {
      const res = await this.$CommonSvc.code()
      this.codeList = res.entity.list
    }
  }
}
</script>

<style scoped></style>
